<template>
  <b-container fluid="lg" class="h-100">
    <b-row class="h-100">
      <b-col class="my-auto">
        <b-row>
          <b-col class="text-center mb-5">
            <b-row class="justify-content-center">
              <b-col cols="3">
                <b-img
                  :src="require('../assets/images/logo.png')"
                  fluid
                  alt="Domeo - assemblées"
                ></b-img>
              </b-col>
            </b-row>
            <b-row class="justify-content-center mt-2">
              <b-col cols="10">
                <h4>
                  {{ $t("general.app_slogan") }}
                </h4>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row v-if="showLoginForm" class="justify-content-center">
          <b-col cols="10" sm="6" md="5" lg="4">
            <b-form>
              <b-row>
                <b-col>
                  <b-alert
                    class="d-flex align-items-center"
                    :show="authError || error"
                    variant="danger"
                  >
                    <font-awesome-icon icon="times-circle" size="2x" />
                    <span v-if="authError" class="ml-2"
                      >Les informations d'identification invalides.</span
                    >
                    <span v-else class="ml-2">Désolé, quelque chose s'est mal passé.</span>
                  </b-alert>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <label>{{ $t("general.Username") }}</label>
                  <b-input v-model="loginData.username" type="text" />
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <label>{{ $t("general.Password") }}</label>
                  <div class="password-input-wrapper">
                    <b-input v-model="loginData.password" :type="inputType" />
                    <font-awesome-icon
                      :icon="inputType == 'password' ? 'eye-slash' : 'eye'"
                      @click="
                        inputType == 'password' ? (inputType = 'text') : (inputType = 'password')
                      "
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row class="justify-content-end mb-4">
                <b-col cols="auto">
                  <router-link :to="{ name: 'forgot-password' }">{{
                    $t("general.Forgot_password")
                  }}</router-link>
                </b-col>
              </b-row>
              <b-row class="justify-content-center">
                <b-col cols="auto">
                  <b-button
                    class="button btn-blue"
                    :disabled="!loginData.username || !loginData.password || isLoadingLogin"
                    type="submit"
                    @click.prevent="login"
                  >
                    <font-awesome-icon
                      v-if="!isLoadingLogin"
                      class="agv-button-icon"
                      icon="sign-in-alt"
                    />
                    <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
                    <span>S'identifier</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>
        <b-row v-if="showDBRemoteProgress" class="justify-content-center">
          <b-col cols="12" sm="10" md="8">
            Veuillez patienter jusqu'à ce que la base de données et les fichiers sont téléchargé.
            <b-progress
              height="2rem"
              :value="progressValue"
              show-progress
              animated
              variant="dark"
              class="mb-2"
            ></b-progress>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col cols="12" sm="10" md="8">
            <b-alert class="my-5 text-center" :show="databaseIsEmpty" variant="primary">
              Vous devez être connecté à Internet pour initialiser l'application.
            </b-alert>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import UserMW from "@/middlewares/User";
import RemoteDBMW from "@/middlewares/RemoteDB";
import remoteDBMixins from "@/mixins/remote-db.js";

export default {
  mixins: [remoteDBMixins],
  data() {
    return {
      loginData: {
        username: "",
        password: "",
      },
      inputType: "password",
      isLoadingLogin: false,
      // for login DESKTOP
      userIsInDB: false,
      databaseIsEmpty: false,
      showLoginForm: true,
      showDBRemoteProgress: false,
      authError: false,
      error: false,
      progressValue: 0,
    };
  },
  async created() {
    this.$store.dispatch("entities/deleteAll");

    if (!process.env.VUE_APP_IS_WEB) {
      // check if there is a user in local DB
      await UserMW.CHECK_USER_IS_IN_DB()
        .then(res => {
          this.userIsInDB = res;
        })
        .catch(err => console.log("err", err));
      // check if all the remote DB was downloaded
      await RemoteDBMW.CHECK_DB_IN_EMPTY()
        .then(res => {
          this.databaseIsEmpty = res;
        })
        .catch(err => console.log("err", err));
    }
  },
  methods: {
    login() {
      this.isLoadingLogin = true;
      this.authError = false;
      this.error = false;

      if (!process.env.VUE_APP_IS_WEB) {
        if (this.userIsInDB) {
          this.$store
            .dispatch("auth/loginDesktop", this.loginData)
            .then(res => {
              if (this.databaseIsEmpty) {
                this.$store
                  .dispatch("auth/login", this.loginData)
                  .then(res => {
                    this.isLoadingLogin = false;

                    this.showLoginForm = false;
                    this.showDBRemoteProgress = true;

                    // start the remote process
                    console.log("start the remote process");
                    this.remoteDB();
                    // this.$store.dispatch("auth/setAuthentication", true);
                  })
                  .catch(err => {
                    this.isLoadingLogin = false;
                    console.log("error", err);

                    if (err.message == "Authentication Failed.") {
                      this.authError = true;
                      return;
                    }
                    this.error = true;
                  });
              } else {
                this.showLoginForm = false;
                this.$store.dispatch("auth/setAuthentication", true);
                this.$router.push({ name: "home" });
              }
            })
            .catch(err => {
              this.isLoadingLogin = false;
              console.log("error", err);

              if (err.message == "Authentication Failed.") {
                this.authError = true;
                return;
              }
              this.error = true;
            });
        } else {
          this.$store
            .dispatch("auth/login", this.loginData)
            .then(res => {
              this.$store
                // REVIEW: commit("auth") and commit("auth_desktop")
                // is setted 2 times in this case...
                .dispatch("auth/checkUser", this.loginData)
                .then(async res => {
                  this.isLoadingLogin = false;
                  this.userIsInDB = true;

                  this.databaseIsEmpty = true;
                  this.showLoginForm = false;
                  this.showDBRemoteProgress = true;

                  await this.remoteDB().then(isRemoteSyncDone => {
                    this.$store.dispatch("auth/setAuthentication", true); // ???: not enough
                    this.$router.push({ name: "home" });
                  });
                })
                .catch(err => {
                  this.isLoadingLogin = false;
                  console.log("err", err);

                  // ???: more detailed error message??
                  this.error = true;
                });
            })
            .catch(err => {
              this.isLoadingLogin = false;
              console.log("err", err);

              // ???: more detailed error message??
              this.error = true;
            });
        }
      } else {
        this.$store
          .dispatch("auth/login", this.loginData)
          .then(res => {
            this.isLoadingLogin = false;
            this.$store.dispatch("auth/setAuthentication", true);
            this.$router.push({ name: "home" });
            this.getMediaId();
          })
          .catch(err => {
            this.isLoadingLogin = false;
            console.log("err", err);

            if (err.response) {
              if (err.response.status === 401) this.authError = true;
              return;
            }
            this.error = true;
          });
      }
    },
    async getMediaId() {
      if (localStorage.getItem("userMediaId") === null) {
        await UserMW.GET(Number(localStorage.getItem("userId")))
          .then(res => {
            localStorage.setItem("userMediaId", res.mediaId);
          })
          .catch(err => {
            console.log("err", err);
          });
      }
      // console.log("userMediaId: ", localStorage.getItem("userMediaId"));
    },
  },
};
</script>
